// Shared builders for the creature prefab groups (creatures_*.ts): the voxel
// `box()` and the generic `humanoid()` part set.
// Voxel scale: 1 unit = 1/16 of a game unit (0.0625).
import type { BlockVoxel, CharacterPart } from './types.js';

export function box(
  sx: number,
  sy: number,
  sz: number,
  w: number,
  h: number,
  d: number,
  color: string,
): BlockVoxel[] {
  const out: BlockVoxel[] = [];
  for (let x = sx; x < sx + w; x++)
    for (let y = sy; y < sy + h; y++)
      for (let z = sz; z < sz + d; z++) out.push({ x, y, z, color });
  return out;
}

export function humanoid(
  headColor: string,
  bodyColor: string,
  legColor: string,
  armColor: string,
  eyeColor: string,
  headH: number,
  bodyBase: number,
  bodyH: number,
  hasHelm?: boolean,
): CharacterPart[] {
  const hx = -2;
  const hy = bodyBase + bodyH;
  const hz = -1;
  const hw = 4;
  const hh = headH;
  const hd = 4;
  const head: BlockVoxel[] = [
    ...box(hx, hy, hz, hw, hh, hd, headColor),
    { x: -1, y: hy + 2, z: hz + hd, color: eyeColor },
    { x: 1, y: hy + 2, z: hz + hd, color: eyeColor },
  ];
  if (hasHelm) head.push(...box(-1, hy + hh, 0, 2, 2, 2, headColor));

  return [
    { name: 'head', voxels: head },
    { name: 'body', voxels: box(-2, bodyBase, 0, 4, bodyH, 2, bodyColor) },
    { name: 'left_arm', voxels: box(-4, bodyBase + 1, 0, 2, bodyH - 1, 2, armColor) },
    { name: 'right_arm', voxels: box(2, bodyBase + 1, 0, 2, bodyH - 1, 2, armColor) },
    { name: 'left_leg', voxels: box(-2, 0, 0, 2, bodyBase, 2, legColor) },
    { name: 'right_leg', voxels: box(0, 0, 0, 2, bodyBase, 2, legColor) },
  ];
}
